import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { SharedModule } from '@aiwyn/shared';
import { CrlActionRequiredSummary } from '../../../../models';

/**
 * Action-required banner (REQ-14). Rendered by the container only when the
 * summary's `show` flag is set (overdue or needs-update items exist) — a
 * property of the request itself, so the banner stays put while its filter is
 * applied rather than disappearing under its own CTA.
 *
 * The CTA carries no `aria-pressed`: its label already names the next action, and
 * a control that does both announces as "Clear Filters, pressed".
 */
@Component({
  selector: 'cxp-crl-action-banner',
  templateUrl: './crl-action-banner.component.html',
  styleUrls: ['./crl-action-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule],
})
export class CrlActionBannerComponent {
  readonly summary = input.required<CrlActionRequiredSummary>();
  readonly filterActive = input<boolean>(false);
  readonly filterRequested = output<void>();

  protected readonly ctaLabel = computed(() => (this.filterActive() ? 'Clear Filters' : 'Filter Requests'));

  protected readonly message = computed(() => {
    const { count } = this.summary();
    const noun = count === 1 ? 'request needs' : 'requests need';
    return `${count} ${noun} your attention`;
  });
}
